<template>
  <div class="domain-help">
    <button type="button" class="domain-help__toggle" :aria-expanded="expanded" @click="expanded = !expanded">
      <SatIcon name="info" :size="16" />
      <span>{{ $t("satellites.domains.help.title") }}</span>
      <SatIcon name="chevron" :size="16" class="domain-help__chevron" :class="{ _open: expanded }" />
    </button>
    <ol v-show="expanded" class="domain-help__steps">
      <li>{{ $t("satellites.domains.help.step_add") }}</li>
      <li>
        {{ $t("satellites.domains.help.step_router") }}
        <router-link :to="{ name: 'SatelliteRouters' }" class="sat-link">{{ $t("satellites.tabs.routers") }}</router-link>
      </li>
      <li>
        {{ $t("satellites.domains.help.step_dns") }}
        <span class="domain-help__note">{{ $t("satellites.domains.help.step_dns_cloudflare") }}</span>
      </li>
      <li>{{ $t("satellites.domains.help.step_ssl") }}</li>
      <li>
        {{ $t("satellites.domains.help.step_link") }}
        <router-link :to="{ name: 'SatelliteLinks' }" class="sat-link">{{ $t("satellites.tabs.links") }}</router-link>
      </li>
    </ol>
  </div>
</template>
<script>
import SatIcon from "@/components/Satellites/SatIcon.vue";

export default {
  name: "DomainHelp",
  components: { SatIcon },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { expanded: this.open };
  },
};
</script>
<style lang="scss" scoped>
.domain-help {
  padding: 14px 18px;
  border-radius: 14px;
  background: var(--sat-surface);
}

.domain-help__toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0;
  border: 0;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: var(--sat-text);
  background: transparent;
  cursor: pointer;

  > .sat-icon:first-child {
    color: var(--sat-accent);
  }

  &:focus {
    outline: none;
  }
}

.domain-help__chevron {
  margin-left: auto;
  color: var(--sat-muted);
  transition: transform 0.2s;

  &._open {
    transform: rotate(180deg);
  }
}

.domain-help__steps {
  margin: 12px 0 0;
  padding-left: 46px;
  font-size: 13px;
  line-height: 1.55;
  color: var(--sat-text-2);

  li + li {
    margin-top: 8px;
  }
}

.domain-help__note {
  display: block;
  margin-top: 4px;
  color: var(--sat-muted);
}
</style>
